// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__mZ_aA {
  height: 100%;
  width: 100%;
  display: grid;
  place-content: center;
  justify-items: center;
  min-height: 100px;
}

.error-container__SClXi {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.spinner__WRsEA {
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 4px solid var(--progress-bar-blue);
  animation: s10-1__AfKob 0.8s infinite linear alternate, s10-2__PrXjF 1.6s infinite linear;
}

@keyframes s10-1__AfKob {
  0% {
    -webkit-clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
            clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
  }
  12.5% {
    -webkit-clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 0%,
      100% 0%,
      100% 0%
    );
            clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 0%,
      100% 0%,
      100% 0%
    );
  }
  25% {
    -webkit-clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      100% 100%,
      100% 100%
    );
            clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      100% 100%,
      100% 100%
    );
  }
  50% {
    -webkit-clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
            clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  62.5% {
    -webkit-clip-path: polygon(
      50% 50%,
      100% 0,
      100% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
            clip-path: polygon(
      50% 50%,
      100% 0,
      100% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  75% {
    -webkit-clip-path: polygon(
      50% 50%,
      100% 100%,
      100% 100%,
      100% 100%,
      100% 100%,
      50% 100%,
      0% 100%
    );
            clip-path: polygon(
      50% 50%,
      100% 100%,
      100% 100%,
      100% 100%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  100% {
    -webkit-clip-path: polygon(
      50% 50%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      0% 100%
    );
            clip-path: polygon(
      50% 50%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      0% 100%
    );
  }
}
@keyframes s10-2__PrXjF {
  0% {
    transform: scaleY(1) rotate(0deg);
  }
  49.99% {
    transform: scaleY(1) rotate(135deg);
  }
  50% {
    transform: scaleY(-1) rotate(0deg);
  }
  100% {
    transform: scaleY(-1) rotate(-135deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/status/style.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,yFAA2E;AAC7E;;AAEA;EACE;IACE,gFAAwE;YAAxE,wEAAwE;EAC1E;EACA;IACE;;;;;;;;KAQC;YARD;;;;;;;;KAQC;EACH;EACA;IACE;;;;;;;;KAQC;YARD;;;;;;;;KAQC;EACH;EACA;IACE;;;;;;;;KAQC;YARD;;;;;;;;KAQC;EACH;EACA;IACE;;;;;;;;KAQC;YARD;;;;;;;;KAQC;EACH;EACA;IACE;;;;;;;;KAQC;YARD;;;;;;;;KAQC;EACH;EACA;IACE;;;;;;;;KAQC;YARD;;;;;;;;KAQC;EACH;AACF;AACA;EACE;IACE,iCAAiC;EACnC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".container {\n  height: 100%;\n  width: 100%;\n  display: grid;\n  place-content: center;\n  justify-items: center;\n  min-height: 100px;\n}\n\n.error-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n}\n\n.spinner {\n  width: 50px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  border: 4px solid var(--progress-bar-blue);\n  animation: s10-1 0.8s infinite linear alternate, s10-2 1.6s infinite linear;\n}\n\n@keyframes s10-1 {\n  0% {\n    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);\n  }\n  12.5% {\n    clip-path: polygon(\n      50% 50%,\n      0 0,\n      50% 0%,\n      100% 0%,\n      100% 0%,\n      100% 0%,\n      100% 0%\n    );\n  }\n  25% {\n    clip-path: polygon(\n      50% 50%,\n      0 0,\n      50% 0%,\n      100% 0%,\n      100% 100%,\n      100% 100%,\n      100% 100%\n    );\n  }\n  50% {\n    clip-path: polygon(\n      50% 50%,\n      0 0,\n      50% 0%,\n      100% 0%,\n      100% 100%,\n      50% 100%,\n      0% 100%\n    );\n  }\n  62.5% {\n    clip-path: polygon(\n      50% 50%,\n      100% 0,\n      100% 0%,\n      100% 0%,\n      100% 100%,\n      50% 100%,\n      0% 100%\n    );\n  }\n  75% {\n    clip-path: polygon(\n      50% 50%,\n      100% 100%,\n      100% 100%,\n      100% 100%,\n      100% 100%,\n      50% 100%,\n      0% 100%\n    );\n  }\n  100% {\n    clip-path: polygon(\n      50% 50%,\n      50% 100%,\n      50% 100%,\n      50% 100%,\n      50% 100%,\n      50% 100%,\n      0% 100%\n    );\n  }\n}\n@keyframes s10-2 {\n  0% {\n    transform: scaleY(1) rotate(0deg);\n  }\n  49.99% {\n    transform: scaleY(1) rotate(135deg);\n  }\n  50% {\n    transform: scaleY(-1) rotate(0deg);\n  }\n  100% {\n    transform: scaleY(-1) rotate(-135deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__mZ_aA`,
	"error-container": `error-container__SClXi`,
	"spinner": `spinner__WRsEA`,
	"s10-1": `s10-1__AfKob`,
	"s10-2": `s10-2__PrXjF`
};
export default ___CSS_LOADER_EXPORT___;
